import { UrlApi } from "../../../services/apirest";
import * as helpers from "./helpers"
import {getUserBranchesFilter} from "../../../utils/filters"


//CLIENTES
export const fetchAllClientes = (texto, setClientes, aUsuario, setCargando, setNoOptionsText, userSucData) => {
    const esGenerico = aUsuario ? 1 : 0;
    setCargando(true);
    const userSucAlias = userSucData?.id_alias || null;
    const sucs = getUserBranchesFilter(userSucAlias);
    const ruta = `${UrlApi}/allClientes/clientes-domicilios/sucs/${sucs}/${esGenerico}/search?q=${encodeURIComponent(texto)}`;

    fetch(ruta)
        .then((res) => res.json())
        .then((data) => {
            setClientes(data);
            if (data.length === 0) {
                setNoOptionsText("No se encontraron clientes.");
            }
        })
        .catch((err) => {
            console.error("Error fetch clientes:", err);
            setClientes([]);
        })
        .finally(() => setCargando(false));
};

//DOMICILIOS
//ACA AGREGAR PONER LA DIRECCION FISCAL COMO DIR DE ENTREGA EN CASO DE QUE NO TENGA DIRS DE ENTREGA
export const fetchDomicilios = async (clienteSeleccionado, setDirecciones, parametrosNegocio) => {
    const { id, id_negocio_cliente, direccion_fiscal } = clienteSeleccionado;
    const {ruta_dir_entrega} = helpers.parseNegocioParams(parametrosNegocio, id_negocio_cliente);

    await fetch(`${UrlApi}${ruta_dir_entrega}${id}`)
        .then((res) => res.json())
        .then((data) => {
            setDirecciones(data);
        })
        .catch((err) => {
            console.error("Error fetch domicilios:", err);
            setDirecciones([]);
        })

}

export async function getProductoXIdDir(ruta, idDir) {
    const idProducto = await fetch(`${UrlApi}${ruta}${idDir}`)
        .then((data) => (data.json()))
        .then((data) => data[0]?.id_producto || null)
    return idProducto;
}

export async function getPrecios(ruta) {
    const precios = await fetch(ruta)
        .then((data) => (data.json()))
    return precios[0];
}

export const getUnidadesMedida = async (setUM) => {
    fetch(UrlApi + "/unidad_medida/mostrar")
        .then(response => response.json())
        .then(data => {
            setUM(data)
        });
}

export const obtenerProductos = async (
    usos, 
    setProductos
    ) => {
    const response = await fetch(UrlApi + `/productos/id_uso/${usos}`) //Esta es la ruta que se debe usar realmente, usamos la de abajo porque de momento es solo para propelente.
    // const response = await fetch(UrlApi + `/productos/propelente`) 
    const data = await response.json()
    setProductos(data)
}

export const getDataSucUsuario = async (idSucUser,) => {
    return await fetch(`${UrlApi}/sucursales/${idSucUser}`)
        .then((data) => data.json())
        .then((data) => {
            return data[0]
        });
}

export const getEmpresasFacturadoras = async () => {
    return await fetch(`${UrlApi}/empresas/facturadoras`)
        .then((data) => data.json())
        .then((data) => {
            return data
        });
}

export const getEmpresasPorNegocio = async () => {
    return await fetch(`${UrlApi}/empresas/por-negocio/facturadoras`)
        .then((data) => data.json())
        .then((data) => {
            return data
        });
}

export const getSucursales = async () => {
    return await fetch(`${UrlApi}/sucursales`)
        .then((data) => data.json())
        .then((data) => {
            return data
        });
}

export const getComprobantesCliente = async (idCliente, setComprobantes, envasado) => {
    return await fetch(`${UrlApi}/comprobantes/facturas_para_anular/${idCliente}/${envasado}`)
        .then((data) => data.json())
        .then((data) => {
            setComprobantes(data)
        });
}

export const getItemsComprobante = async (uuidComprobante, setItems) => {
    return await fetch(`${UrlApi}/comprobantes/items_facturas/${uuidComprobante}`)
        .then((data) => data.json())
        .then((data) => {
            setItems(data)
        });
}

export const getComprobanteEmitido = async (idComprobante, setComprobante) => {
    return await fetch(`${UrlApi}/comprobantes/byidcomprobante/${idComprobante}`)
        .then((data) => data.json())
        .then((data) => {
            setComprobante(data)
        });
}

export const getSucursalesEmpresa = async (idEmpresa) => {
    return await fetch(`${UrlApi}/sucursales/empresayotra/${idEmpresa}`)
        .then((data) => data.json())
        .then((data) => {
            return data
        });
}